import { InjectionToken } from '@angular/core';
import { TradingProcedureListQueryPort } from '../ports/trading-procedure-list-query.port';
import { TradingProcedureListEventsPort } from '../ports/trading-procedure-list-events.port';

export const TRADING_PROCEDURE_LIST_QUERY_TOKEN = new InjectionToken<TradingProcedureListQueryPort>('TradingProcedureListQueryPort');
export const TRADING_PROCEDURE_LIST_EVENTS_TOKEN = new InjectionToken<TradingProcedureListEventsPort>('TradingProcedureListEventsPort');

